<div class="salons-page">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="overview-hero">
    <div class="hero-copy">
      <span class="hero-kicker">Business Locations</span>

      <h1>Manage <span>Salons</span></h1>

      <p>
        Manage your salon locations, contact details, owners, and business
        profile from one clean workspace.
      </p>
    </div>

    <div class="hero-actions">
      <button
        type="button"
        class="overview-btn overview-btn--dark"
        (click)="openAddSalonModal()"
      >
        Add Salon
      </button>
    </div>
  </section>

  <section class="kpi-grid">
    <article class="kpi-card kpi-card--primary">
      <div>
        <span>Total Salons</span>
        <strong>{{ salons.length }}</strong>
        <p>Total salon locations loaded for this business account.</p>
      </div>

      <!-- <img [src]="assetUrl + 'icons/marker-lg.svg'" alt="" /> -->
    </article>

    <article class="kpi-card">
      <div>
        <span>With Contact</span>
        <strong>{{ salonsWithContact }}</strong>
        <p>Locations with phone and email details available.</p>
      </div>

      <img [src]="assetUrl + 'icons/users-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Business Types</span>
        <strong>{{ businessTypeCount }}</strong>
        <p>Unique salon categories represented across your locations.</p>
      </div>

      <img [src]="assetUrl + 'icons/doc-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Staff</span>
        <strong>{{ totalStaff }}</strong>
        <p>Total staff count recorded across all salon locations.</p>
      </div>

      <img [src]="assetUrl + 'icons/users-border.svg'" alt="" />
    </article>
  </section>

  <section class="panel">
    <header class="panel-head">
      <div>
        <span class="panel-kicker">Salon Directory</span>
        <h2>Salon List</h2>
        <p>Search, edit, or delete your salon locations.</p>
      </div>

      <div class="panel-actions">
        <glo-control
          icon="search"
          placeholder="Search by name, city or address"
          classes="bg-gray-50"
          (valueChange)="onSearch($event)"
        >
        </glo-control>
      </div>
    </header>

    @if (!isLoading && salons.length === 0) {
      <div class="empty-state">
        <div class="empty-icon">S</div>

        <strong>No salons found</strong>

        <p>
          Add your first salon location to begin managing services,
          appointments, and customer bookings.
        </p>

        <button
          type="button"
          class="overview-btn overview-btn--dark"
          (click)="openAddSalonModal()"
        >
          Add Salon
        </button>
      </div>
    } @else {
      <div class="table-shell">
        <table>
          <thead>
            <tr>
              <th>Salon</th>
              <th>Owner</th>
              <th>Business Type</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Location</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            @for (salon of viewSalons; track salon.salon_id) {
              <tr>
                <td>
                  <div class="salon-cell">
                    <div class="salon-avatar">
                      {{ getSalonInitial(salon) }}
                    </div>

                    <div>
                      <strong>{{ salon.name || "Unnamed Salon" }}</strong>
                      <span>
                        {{ salon.description || "No description added" }}
                      </span>
                    </div>
                  </div>
                </td>

                <td>
                  {{ getOwnerName(salon) }}
                </td>

                <td>
                  <span class="type-pill">
                    {{
                      formatBusinessType(getSalonValue(salon, "businessType"))
                    }}
                  </span>
                </td>

                <td>
                  {{ getSalonValue(salon, "phone") || "No phone" }}
                </td>

                <td>
                  {{ getSalonValue(salon, "email") || "No email" }}
                </td>

                <td>
                  <div class="location-cell">
                    <strong>
                      {{ getSalonValue(salon, "address") || "No address" }}
                    </strong>
                    <span>
                      {{ getSalonValue(salon, "city") || "No city" }}
                    </span>
                  </div>
                </td>

                <td>
                  <div class="row-actions">
                    <button type="button" (click)="openEditModal(salon)">
                      Edit
                    </button>

                    <button
                      type="button"
                      class="danger"
                      (click)="deleteSalon(salon)"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <glo-pagination
        *ngIf="filteredSalons.length > 0"
        [totalItems]="filteredSalons.length"
        [currentPage]="currentPage"
        [itemsPerPage]="itemsPerPage"
        [itemsPerPageOptions]="[10, 20, 50, 100]"
        (currentPageChange)="onPageChange($event)"
        (itemsPerPageChange)="onItemsPerPageChange($event)"
      >
      </glo-pagination>
    }
  </section>

  <div class="mobile-action">
    <button
      type="button"
      class="overview-btn overview-btn--dark"
      (click)="openAddSalonModal()"
    >
      Add Salon
    </button>
  </div>
</div>
